import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../api-endpoints-constants';
import { IApiBaseObject } from '../../iModels/api-base-object.model';
import { IApiService } from '../../iservices/iApi';
import { ModelBindingService } from '../binding.model.service';
import { map } from 'rxjs/operators';
import { ModelDecoderBindingService } from '../bindingDecoder.model.service';
import { BehaviorSubject } from 'rxjs';
import { IELementMasterService } from '../../iservices/iMasterServices/iElementMaster';
import { MatDialog } from '@angular/material/dialog';
import {
  AddPropertyMasterComponent
} from '../../component/master/masterComponents/property-master/add-property-master/add-property-master.component';

@Injectable({
  providedIn: 'root'
})
export class ElementMasterService implements IELementMasterService {
  dataHasBeenDeleted = new BehaviorSubject(false);
  tableUpdated = new BehaviorSubject(false);
  private apiObject: IApiBaseObject;
  constructor( @Inject('IApiService') private apiService: IApiService,
    private modelBindingService: ModelBindingService,
    private modelDecoderBindingService: ModelDecoderBindingService,
    public dialog: MatDialog) {

  }
  /*
    * @method getPropertyMasterDetails()
    * @desc used to get PropertyMaster list .
    * @return json array data.
  */
  getElements(apiGetParameters): any {
    let json;
    // apiGetParameters.page = apiGetParameters.page ? apiGetParameters.page : 1;
    // apiGetParameters.size = apiGetParameters.size === 0 || apiGetParameters.size ? apiGetParameters.size : 10;
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.ELEMENT_MASTER_ADD, apiGetParameters);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp) => {
        if (resp) {
          resp['data'] = this.modelDecoderBindingService
            .mappingDataReturn('elementMasterDecoder', resp);
          // const json =  { data: resp['data'].data, 'itemCount': resp['data'].data[0].totalRows };
          if (resp['data'].data) {
            json = { data: resp['data'].data, 'itemCount': resp['data'].data[0].totalRows };
          } else {
            json = { data: resp['data'].data, 'itemCount': 0 };
          }
          return json;
        }
      }
      ));
  }
  /*
    * @method addPropertyMaster()
    * @desc used to add PropertyMaster Type.
    * @param permData :array - PropertyMaster data.
    * @return json array data.
  */
  addElementMaster(permData): any {
    const requestData = this.modelBindingService.elementMasterEncoder(permData);
    this.apiObject = this.modelBindingService.setApiCallObject(API_ENDPOINTS.ELEMENT_MASTER_ADD, requestData,
      true, false);
    return this.apiService.postApi(this.apiObject).pipe(
      map((res) => {
        return res;
      },
        (error) => {
          return error;
        }
      ));
  }

  /*
   * @method delete()
   * @desc used to property masterrow data.
   * @param id :array - property master id .
   * @return string.
  */
  delete(id): string {
    const url = this.modelBindingService.replaceUrlForDelete(
      API_ENDPOINTS.ELEMENT_MASTER_ADD, id);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.deleteApi(this.apiObject).pipe(
      map((response) => {
        return response;
      },
        (error) => {
          return error;
        }));
  }
}
